export const STATUS_SEARCH = 'STATUS_SEARCH'